// src/lib/schema/helpers/dateHelpers.js


/**
 * Get a date X units in the future
 * @param {number} amount - Amount to add
 * @param {string} unit - Unit (day, month, year)
 * @returns {string} ISO date string YYYY-MM-DD
 */
export function getValidUntilDate(amount = 1, unit = 'year') {
  const date = new Date();

  switch(unit.toLowerCase()) {
    case 'day':
      date.setDate(date.getDate() + amount);
      break;
    case 'month':
      date.setMonth(date.getMonth() + amount);
      break;
    case 'year':
    default:
      date.setFullYear(date.getFullYear() + amount);
  }

  return formatISODate(date);
}

/**
 * Format a date as ISO YYYY-MM-DD
 * @param {Date} date - Date object
 * @returns {string} Formatted date
 */
export function formatISODate(date) {
  return date.toISOString().split('T')[0];
}

/**
 * Get last modified date for a content item
 * @param {string} id - Content ID
 * @param {object} contentData - Optional data object with lastUpdated field
 * @returns {string} ISO date string
 */
export function getLastModifiedDate(id, contentData = null) {
  // If data has a lastUpdated property, use it
  if (contentData && contentData.lastUpdated) {
    return contentData.lastUpdated;
  }

  // Otherwise return current date
  return new Date().toISOString();
}

/**
 * Format a date for schema.org serialization (ISO 8601)
 * @param {Date|string} date - Date object or ISO string
 * @returns {string} Formatted date string
 */
export function formatSchemaDate(date) {
  if (!date) {
    return new Date().toISOString();
  }

  if (typeof date === 'string') {
    // Check if it's already in ISO format
    if (date.includes('T') && date.includes('Z')) {
      return date;
    }

    // Try to parse the string as a date
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toISOString();
    }

    // If parsing failed, return current date
    return new Date().toISOString();
  }

  // If it's a Date object
  if (date instanceof Date) {
    return date.toISOString();
  }

  // Default to current date
  return new Date().toISOString();
}

/**
 * Calculate expiration date for price validity
 * Often used for offers in product schema
 * @param {number} days - Number of days in the future
 * @returns {string} ISO 8601 date string
 */
export function getPriceValidityDate(days = 365) {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return formatISODate(date);
}
